import React from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  SelectProps,
  Theme,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import {
  StyledInputLabel,
  StyledOutlinedInput,
  StyledHelperText,
  StyledDescription,
} from '@bizapp-lp/workflow/molecules/StyledInput';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    select: {
      '& .MuiSelect-selectMenu': {
        minHeight: '32px', // to adjust input area
        lineHeight: '20px', // to adjust text
      },
    },
    item: {
      height: '32px',
      minHeight: 'initial',
    },
    hidden: { display: 'none' },
  }),
);

export interface StyledSelectProps extends SelectProps {
  options: Map<string, React.ReactNode>;
  helperText?: React.ReactNode;
  description?: React.ReactNode;
}

export const StyledSelect: React.FC<StyledSelectProps> = ({
  className = '',
  id,
  label,
  required = false,
  error = false,
  disabled = false,
  hidden = false,
  options,
  helperText,
  description,
  ...props
}: StyledSelectProps) => {
  const classes = useStyles();

  return (
    <FormControl
      required={required}
      error={error}
      disabled={disabled}
      className={`${hidden ? classes.hidden : ''} ${className}`}
    >
      <StyledInputLabel htmlFor={id}>{label}</StyledInputLabel>
      <Select
        {...props}
        id={id}
        input={<StyledOutlinedInput />}
        className={classes.select}
      >
        {Array.from(options.entries()).map((kv, i) => {
          const [key, value] = kv;
          return (
            <MenuItem value={key} key={`${id}-${i}`} className={classes.item}>
              {value}
            </MenuItem>
          );
        })}
      </Select>
      {helperText && error && <StyledHelperText children={helperText} />}
      {description && <StyledDescription children={description} />}
    </FormControl>
  );
};
